import React from 'react'
import Navbar from '../components/navbar/navbar'
import Footer from '../components/footer/Footer'
import MeetTheTeam from '../components/portfolio/MeetTheTeam'

const MeetTheTeamPage = () => {
  return (
    <div className='meet-the-team-page'>
      <Navbar />
      <MeetTheTeam />
      <Footer />
    </div>
  )
}

export default MeetTheTeamPage